import React from "react";
import Logo from "../../img/logo.png";

const LandingFooter = () => {
    return (
        <footer className="bg-gray-900 text-gray-500 py-12 border-t border-gray-800 text-center relative z-10">
            <div className="max-w-7xl mx-auto px-4 flex flex-col items-center gap-4">
                <div className="flex items-center gap-2 opacity-50">
                    <img src={Logo} alt="Logo" className="h-8 w-auto bg-white rounded p-1" />
                    <span className="font-semibold text-gray-400">ATECMA</span>
                </div>
                <p className="text-sm">ATECMA Ltda. &copy; {new Date().getFullYear()} - Todos los derechos reservados.</p>
            </div>
        </footer>
    );
};

export default LandingFooter;
